var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveBidding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 12.5834C12.6795 14.2976 15.1111 16.0398 15.1111 16.0398L18.4444 12.9445C18.4444 12.9445 16.5684 10.6865 14.7223 8.97221C12.8761 7.25794 10.4444 5.51587 10.4444 5.51587L7.11111 8.61111C7.11111 8.61111 8.9872 10.869 10.8333 12.5834ZM10.8333 12.5834L5 18M19 12.4285L14.5555 16.5555M11.0001 5L6.55556 9.12701",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveBidding);
export default __webpack_public_path__ + "static/media/inactive-bidding.c054b5e2f1695511590b8b3ce1cfb363.svg";
export { ForwardRef as ReactComponent };